<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date"  (ngModelChange)="changeEvent()"class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date"  (ngModelChange)="changeEvent()" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-2">
        <mat-label>Select Product</mat-label>
        <mat-select [(ngModel)]="selected_product_type_id" class="main-border-class" (ngModelChange)="changeEvent()">
          <mat-option [value]="product.id" *ngFor="let product of product_type">{{product['group_name']}}</mat-option>
        </mat-select>
      </div>
      <div class="col-1">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 11%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-3" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>
    </div>
  </div>
  <!-- <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null"></iframe> -->
</section>
